import React from 'react'
import PropTypes from 'prop-types'
import { Button as AntButton } from 'antd'
import './button.scss'

const Button = ({
  children,
  type = 'default',
  size = 'middle',
  icon,
  loading = false,
  disabled = false,
  danger = false,
  block = false,
  className = '',
  onClick,
  ...props
}) => {
  const buttonClass = `app-button app-button-${type} ${className}`

  return (
    <AntButton
      type={type}
      size={size}
      icon={icon}
      loading={loading}
      disabled={disabled}
      danger={danger}
      block={block}
      className={buttonClass}
      onClick={onClick}
      {...props}
    >
      {children}
    </AntButton>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'text', 'link']),
  size: PropTypes.oneOf(['large', 'middle', 'small']),
  icon: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  block: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default Button
